import Vue from 'vue'
import Router from 'vue-router'
import home from '../views/home.vue'
import store from '@/store'
import bus from '@/utils/bus'


Vue.use(Router)

const constantRoutes = [
  {
    path: '/',
    component: home
  },
  
]

const router = new Router({
  mode: 'hash',
  routes: constantRoutes,
})
router.beforeEach((to, from, next) => {
  next()
  
});

router.afterEach((to, from) => {
  return true
})

export default router
